export default {
  links: {},
  pagination: {},
  downloads: [],
  backupLimit: undefined,
  backupProcessing: false,
};
